// ©2024 Austin App House. All rights reserved.
import React from 'react';
import Sel from './Sel';

const Row = ({
  columns,
  item,
  enableActionsCol,
  ActionElement,
}) => (
  <tr>
    {
      columns.map(col => (
        <Sel
          key={col.value}
          col={col}
          item={item}
        />
      ))
    }
    {
      enableActionsCol
        ? (
          <td className="actions-col">
            <ActionElement item={item} />
          </td>
        )
        : <></>
    }
  </tr>
);

export default Row;
